<div class="mb-3">
  <h1 class="pb-2 border-bottom fw-light" data-testid="order-receipt-heading" i18n="@@orderReceipt.title">Bestellbeleg</h1>

  @if (order) {
    <p class="text-muted" i18n>Vorschau in der eingestellten Belegbreite von {{ widthCm }} cm.</p>
    <app-order-receipt [order]="order" [widthCm]="widthCm" [watermark]="watermark"></app-order-receipt>
  }

  <div class="mt-3">
    <button class="btn btn-secondary m-2" type="button" (click)="onBackClicked()" i18n>Zurück</button>
    @if (order && profile?.isActive) {
      <button
        class="btn btn-primary m-2"
        type="button"
        data-testid="order-receipt-print-button"
        [asyncClick]="print.bind(this)"
        [disabled]="printBtn.disabled"
        #printBtn="asyncClick"
        i18n
        >
        @if (printBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
        <fa-icon [icon]="faPrint"></fa-icon> Drucken
      </button>
    }
  </div>
</div>
